module.exports = __webpack_public_path__ + "img/qilin-f-stage6.f5d29f38.png";